<div class="col-sm-12 .d-none .d-sm-block .d-md-none d-lg-none">
	<mat-toolbar class="app-header--mobile">
		<mat-toolbar-row class="u-base-colors">
			<a routerLink="/"><img class="app-header__logo--mobile" src="assets/v_Logo_4C.svg" alt="voestaplpine - one step ahead"></a>

			<span class="app-header__filler"></span>

			<button mat-icon-button (click)="toggleSidenav.emit()">
				<mat-icon class="app-header__menu-toggle" fontSet="voest-icons__menu" fontIcon="menu"></mat-icon>
			</button>
		</mat-toolbar-row>
	</mat-toolbar>
</div>

<div class="col-lg-12 d-none d-lg-block">
	<mat-toolbar class="app-header--desktop">
		<mat-toolbar-row class="u-base-colors">
			<a routerLink="/"><img class="app-header__logo--desktop" src="assets/v_Logo_4C.svg" alt="voestaplpine - one step ahead"></a>

			<span class="app-header__filler"></span>

			<div class="app-header__menu">
				<div class="u-justify-items-end mat-subtitle-1 app-header__title"
						 i18n>weldNet® Material Manager</div>

				<div class="u-justify-items-end">
					<ul class="app-header__menu-row mat-body-2">
						<li class="app-header__menu-item">

							<div *ngIf="userInfo?.anonymous === false">
								<a [matMenuTriggerFor]="user" appToggleMenuOnHover>
									{{userInfo?.fullName}}
									<span class="app-header__user-has-extended-access">
										(<span *ngIf="userInfo?.hasExtendedAccess; else freeUser" i18n>Premium</span>
										<ng-template #freeUser><span i18n>Free</span></ng-template>)
									</span>
								</a>
								<mat-menu #user="matMenu" xPosition="before">
									<a [href]="'change-password' | resourcePath" mat-menu-item i18n>Passwort ändern</a>
									<a *ngIf="userInfo?.groupAdminUrl as groupAdminUrl"
										 [href]="groupAdminUrl" target="_blank" mat-menu-item i18n>Gruppenverwaltung</a>
									<a mat-menu-item *ngIf="userInfo?.hasExtendedAccess === true" i18n
										 [href]="'redirect-to-payment' | resourcePath" class="app-header__subscription-link">Aboverwaltung</a>
									<form [action]="'logout' | resourcePath">
										<button type="submit" mat-menu-item i18n>Logout</button>
									</form>
								</mat-menu>
							</div>

							<a class="app-header__link" [href]="'login' | resourcePath" *ngIf="userInfo?.anonymous === true" i18n>Login</a>
						</li>

						<li class="app-header__menu-item">
							<a class="app-header__link" href="https://www.voestalpine.com/welding/" i18n>voestalpine Böhler Welding</a>
						</li>

						<li class="app-header__menu-item">
							<a [matMenuTriggerFor]="languageMenu" class="app-header__language"
								 appToggleMenuOnHover>{{languageService.language}}</a>
							<mat-menu #languageMenu="matMenu" xPosition="before">
								<button mat-menu-item (click)="languageService.changeLanguage('de')"><span class="mat-body-2">Deutsch</span></button>
								<button mat-menu-item (click)="languageService.changeLanguage('en')"><span class="mat-body-2">English</span></button>
								<button mat-menu-item (click)="languageService.changeLanguage('es')"><span class="mat-body-2">Español</span></button>
								<button mat-menu-item (click)="languageService.changeLanguage('it')"><span class="mat-body-2">Italiano</span></button>
								<button mat-menu-item (click)="languageService.changeLanguage('fr')"><span class="mat-body-2">Français</span></button>
							</mat-menu>
						</li>
					</ul>
				</div>
			</div>
		</mat-toolbar-row>
	</mat-toolbar>
</div>

<mat-divider></mat-divider>
